import { render, staticRenderFns } from "./crudCategory.vue?vue&type=template&id=2901481a&"
import script from "./crudCategory.vue?vue&type=script&lang=js&"
export * from "./crudCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports